"use client"

import { VStack } from "@chakra-ui/react/stack"
import { FC } from "react"

import { ContentBlockRenderer } from "@/components/ContentBlockRenderer"
import ErrorMessage from "@/components/ErrorMessage"
import { ContentBlockWrapper, Post } from "@/types/database"
import ProtectedCaseStudyContent from "./ProtectedCaseStudyContent"

export interface SingleContentProps {
  post: Post
  contentLocked?: boolean
  onProtectedContentUnlocked?: () => void
}

const SingleContent: FC<SingleContentProps> = ({
  contentLocked = false,
  onProtectedContentUnlocked,
  post,
}) => {
  const contentBlocks = post?.content_blocks as ContentBlockWrapper[]

  if (contentLocked) {
    return (
      <ProtectedCaseStudyContent
        onUnlocked={onProtectedContentUnlocked}
        slug={post.slug}
      />
    )
  }

  // console.log('contentBlocks', contentBlocks);
  return (
    <>
      {contentBlocks && contentBlocks.length > 0 ? (
        <>
          <ContentBlockRenderer
            className="work-article-content-blocks"
            contentBlocks={contentBlocks}
          />
        </>
      ) : (
        <VStack
          alignItems="center"
          px={{ base: 8, md: 10, lg: 24, xl: 40 }}
          py={{ base: 4, md: 6, lg: 8, xl: 12 }}
        >
          <ErrorMessage
            message="Please add content to the work article, and try again."
            title="Work Article has no content!"
          />
        </VStack>
      )}
    </>
  )
}

export default SingleContent
